module.exports = __webpack_public_path__ + "assets/img/23_26_big.94b8d06c.jpg";